/**
 * Landing-pages-base — client-side categorie-filtering (landing_category-tags).
 *
 * Dunne wrapper op de gedeelde filter-module (resources/js/filter.js): dit blok
 * levert z'n eigen .landing-pages-base__* selectors. Import in
 * resources/js/main.js; self-init op DOM-ready.
 */
import { initFilter } from '../../resources/js/filter.js';

const CONFIG = {
    block: '.landing-pages-base',
    filter: '.landing-pages-base__filter',
    card: '.landing-pages-base__card',
    hiddenClass: 'landing-pages-base__card--hidden',
};

/**
 * Initialiseert alle landing-pages-base-blokken binnen een scope.
 *
 * @param {ParentNode} [scope] - Zoekwortel (default: document).
 */
export function initLandingPagesBase(scope = document) {
    initFilter(CONFIG, scope);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initLandingPagesBase());
} else {
    initLandingPagesBase();
}
